/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetIncidentRecordFile = zod.object({
  "incidentRecordId": zod.string().uuid().optional(),
  "id": zod.string().uuid().optional()
});

export type GetIncidentRecordFile = zod.input<typeof GetIncidentRecordFile>;
export type GetIncidentRecordFileOutput = zod.output<typeof GetIncidentRecordFile>;
